export enum UserStatus {
  Active = 'Active',
  Deactivated = 'Deactivated',
}

export enum AccessStatus {
  Invited = 'Invitation sent',
  Pending = 'Pending',
  Requested = 'Requested access',
}

export const UserStatusColors: Record<UserStatus, { text: string }> = {
  [UserStatus.Active]: {
    text: '#00AB86',
  },
  [UserStatus.Deactivated]: {
    text: '#E9372A',
  },
};

export const AccessStatusColors: Record<AccessStatus, { text: string }> = {
  [AccessStatus.Invited]: {
    text: '#2563EB',
  },
  [AccessStatus.Pending]: {
    text: '#F2A200',
  },
  [AccessStatus.Requested]: {
    text: '#F2A200',
  },
};

export const UserStatusLookUps = [
  ...Object.entries(UserStatus),
  ...Object.entries(AccessStatus),
].map(([value, name]) => ({
  name,
  value,
}));

export function getStatusLabel(statusKey: string): string {
  return (
    UserStatus[statusKey as keyof typeof UserStatus] ??
    AccessStatus[statusKey as keyof typeof AccessStatus] ??
    statusKey
  );
}

export function getStatus(key: string) {
  if (key in UserStatus) {
    return UserStatusColors[UserStatus[key as keyof typeof UserStatus]];
  }

  if (key in AccessStatus) {
    return AccessStatusColors[AccessStatus[key as keyof typeof AccessStatus]];
  }

  return undefined;
}
